<template>
    <div>
        <!-- Main Content -->
        <div class="main-content">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">Dados do Usuário</div>
                        </div>
                        <div class="card-body">
                            <!-- Header principal com foto e status -->
                            <div class="user-details-header justify-content-center">
                                <div class="d-flex flex-column" style="gap: 0">
                                    <div class="d-flex gap-1">
                                        <div class="user-photo-section mr-2">
                                            <div class="circular--landscape">
                                                <img
                                                    v-if="users.photo"
                                                    :src="users.photo"
                                                    alt="Foto do usuário"
                                                    class="tratament"
                                                />
                                                <img
                                                    v-else
                                                    src="@/assets/images/profile.png"
                                                    alt="Foto do usuário"
                                                    class="tratament"
                                                />
                                            </div>
                                        </div>

                                        <div class="user-status-section">
                                            <div class="user-status-info">
                                                <span
                                                    class="status-badge"
                                                    :class="getUserStatusClass()"
                                                >
                                                    {{ getUserStatusText() }}
                                                </span>
                                                <div
                                                    class="user-id"
                                                    v-if="users.id"
                                                >
                                                    #{{ users.id }}
                                                </div>
                                            </div>

                                            <div
                                                class="user-department"
                                                v-if="users.cost_center"
                                            >
                                                <i class="fas fa-building"></i>
                                                <span>{{ users.cost_center.description }}</span>
                                            </div>

                                            <div
                                                class="user-email"
                                                v-if="users.email"
                                            >
                                                <i class="fas fa-envelope"></i>
                                                <span>{{ users.email }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="user-name-badge">
                                        {{ users.name }}
                                        <div
                                            class="user-matriculation"
                                            v-if="users.matriculation"
                                        >
                                            <i class="fas fa-id-card"></i>
                                            {{ users.matriculation }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Grid de informações pessoais -->
                            <div class="section-divider">
                                <div class="titlePR">
                                    <i class="fas fa-user mr-2"></i>
                                    Informações Pessoais
                                </div>
                            </div>

                            <div class="info-cards-grid">
                                <div class="info-card" v-if="users.cpf">
                                    <div class="card-icon">
                                        <i class="fas fa-id-card"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">CPF:</div>
                                        <div class="card-value date-highlight">{{ formatCPF(users.cpf) }}</div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.rg">
                                    <div class="card-icon">
                                        <i class="fas fa-address-card"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">RG:</div>
                                        <div class="card-value date-highlight">{{ formatRG(users.rg) }}</div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.cellphone">
                                    <div class="card-icon">
                                        <i class="fas fa-mobile-alt"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Celular:</div>
                                        <div class="card-value date-highlight">{{ formatPhone(users.cellphone) }}</div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.e_date_of_birth">
                                    <div class="card-icon">
                                        <i class="fas fa-birthday-cake"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Data de Nascimento:</div>
                                        <div class="card-value date-highlight">{{ formatDate(users.e_date_of_birth) }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Seção CNH -->
                            <div class="section-divider" v-if="users.number_cnh">
                                <div class="titlePR">
                                    <i class="fas fa-car mr-2"></i>
                                    Informações da CNH
                                </div>
                            </div>

                            <div class="info-cards-grid" v-if="users.number_cnh">
                                <div class="info-card">
                                    <div class="card-icon">
                                        <i class="fas fa-id-badge"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Número da CNH:</div>
                                        <div class="card-value date-highlight">{{ users.number_cnh }}</div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.e_validity_cnh">
                                    <div class="card-icon">
                                        <i class="fas fa-calendar-times"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Validade da CNH:</div>
                                        <div class="card-value date-highlight">
                                            {{ formatDate(users.e_validity_cnh) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.pri_cnh">
                                    <div class="card-icon">
                                        <i class="fas fa-calendar-plus"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Primeira Habilitação:</div>
                                        <div class="card-value date-highlight">{{ formatDate(users.pri_cnh) }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Seção Dados Funcionais -->
                            <div class="section-divider">
                                <div class="titlePR">
                                    <i class="fas fa-briefcase mr-2"></i>
                                    Dados Funcionais
                                </div>
                            </div>

                            <div class="info-cards-grid">
                                <div class="info-card" v-if="users.admission_date">
                                    <div class="card-icon">
                                        <i class="fas fa-calendar-check"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Data de Admissão:</div>
                                        <div class="card-value date-highlight">{{ formatDate(users.admission_date) }}</div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.access_nivel">
                                    <div class="card-icon">
                                        <i class="fas fa-user-shield"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Nível de Acesso:</div>
                                        <div class="card-value date-highlight">{{ getAccessLevelText(users.access_nivel) }}</div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.erp_code">
                                    <div class="card-icon">
                                        <i class="fas fa-code"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Código ERP:</div>
                                        <div class="card-value date-highlight">{{ users.erp_code }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Seção Permissões e Configurações -->
                            <div class="section-divider">
                                <div class="titlePR">
                                    <i class="fas fa-cogs mr-2"></i>
                                    Permissões e Configurações
                                </div>
                            </div>

                            <div class="info-cards-grid">
                                <div class="info-card">
                                    <div class="card-icon">
                                        <i class="fas fa-satellite-dish"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Telemetria:</div>
                                        <div class="card-value" :class="getStatusClass(users.telemetry)">
                                            {{ users.telemetry == 1 ? 'Sim' : 'Não' }}
                                        </div>
                                    </div>
                                </div>

                                <div class="info-card">
                                    <div class="card-icon">
                                        <i class="fas fa-check-circle"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Aprovador de Reservas:</div>
                                        <div class="card-value" :class="getStatusClass(users.is_approver)">
                                            {{ users.is_approver == 1 ? 'Sim' : 'Não' }}
                                        </div>
                                    </div>
                                </div>

                                <div class="info-card">
                                    <div class="card-icon">
                                        <i class="fas fa-clipboard-list"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Checklist Simplificado:</div>
                                        <div class="card-value" :class="getStatusClass(users.simplified_checklist)">
                                            {{ users.simplified_checklist == 1 ? 'Sim' : 'Não' }}
                                        </div>
                                    </div>
                                </div>

                                <div class="info-card">
                                    <div class="card-icon">
                                        <i class="fas fa-file-contract"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Aceitou Termos:</div>
                                        <div class="card-value" :class="getStatusClass(users.accept_terms)">
                                            {{ users.accept_terms == 1 ? 'Sim' : 'Não' }}
                                        </div>
                                    </div>
                                </div>

                                <div class="info-card" v-if="users.date_accept">
                                    <div class="card-icon">
                                        <i class="fas fa-calendar-alt"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Data do Aceite:</div>
                                        <div class="card-value date-highlight">{{ formatDateTime(users.date_accept) }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Botões de ação -->
                            <div class="action-buttons float-right mt-3">
                                <router-link
                                    to="/users"
                                    class="btn btn-back"
                                >
                                    <i class="fa fa-arrow-left mr-2"></i>
                                    Voltar
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            users: { // dados do usuário
                name: "",
                email: "",
                password: "",
                registry: "",
                photo: "",
                matriculation: "",
                rg: "",
                cpf: "",
                cellphone: "",
                e_date_of_birth: "",
                admission_date: "",
                number_cnh: "",
                e_validity_cnh: "",
                pri_cnh: "",
                access_nivel: "",
                erp_code: "",
                telemetry: 0,
                accept_terms: 0,
                date_accept: "",
                is_approver: 0,
                simplified_checklist: 0,
                cost_center: {
                    description: "",
                },
            },
            branches: { // filiais
                cities: [
                    {
                        title: "",
                    },
                ],
                states: [
                    {
                        title: "",
                    },
                ],
            },
            errors: undefined, // erros de validação
        };
    },
    computed: {},
    methods: {
        // Buscar dados do usuário
        getUsers: function () {
            let self = this;
            let id = self.$route.params.id; // id do usuário pela rota
            let api =
                self.$store.state.api +
                "users/" +
                id +
                "?with[]=costCenter";

            self.$http
                .get(api)
                .then((response) => {
                    self.users = response.data.data[0];
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, self.errors, "error");
                });
        },

        // Formatar CPF
        formatCPF(cpf) {
            if (!cpf) return '';
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        },

        // Formatar RG
        formatRG(rg) {
            if (!rg) return '';
            return rg.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4');
        },

        // Formatar telefone
        formatPhone(phone) {
            if (!phone) return '';
            return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        },

        // Formatar data
        formatDate(date) {
            if (!date) return '';
            if (date.includes('/')) return date; // já formatada
            const d = new Date(date);
            return d.toLocaleDateString('pt-BR');
        },

        // Formatar data e hora
        formatDateTime(datetime) {
            if (!datetime) return '';
            const d = new Date(datetime);
            return d.toLocaleString('pt-BR');
        },

        // Obter classe do status do usuário
        getUserStatusClass() {
            if (this.users.accept_terms == 1) {
                return 'status-approved'; // usuário ativo
            }
            return 'status-pending'; // pendente
        },

        // Obter texto do status do usuário
        getUserStatusText() {
            if (this.users.accept_terms == 1) {
                return 'Ativo';
            }
            return 'Pendente';
        },

        // Obter classe para status sim/não
        getStatusClass(value) {
            return value == 1 ? 'text-success' : 'text-danger';
        },

        // Obter texto do nível de acesso
        getAccessLevelText(level) {
            const levels = {
                1: 'Usuário Padrão',
                2: 'Gestor',
                3: 'Administrador Master',
                4: 'Administrador de Filial'
            };
            return levels[level] || 'Não definido';
        },
    },
    mounted: function () {
        this.getUsers(); // buscar dados ao montar componente
    },
};
</script>

<style scoped>
/* Reutilizando classes existentes e criando apenas estilos específicos */

/* Header principal do usuário */
.user-details-header {
    display: flex;
    gap: 2rem;
    margin-bottom: 2rem;
    padding: 1.5rem;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #FE8D18;
}

.user-photo-section {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.circular--landscape {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tratament {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.user-name-badge {
    background: white;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    text-align: center;
    font-weight: 600;
    color: #333;
    white-space: nowrap;
}

.user-matriculation {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    color: #666;
    font-size: 0.9rem;
}

.user-status-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.user-status-info {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: space-evenly;
}

.user-id {
    font-size: 1.5rem;
    font-weight: 700;
    color: #FE8D18;
}

.user-department,
.user-email {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    color: #495057;
}

.user-department i,
.user-email i {
    color: #FE8D18;
    width: 20px;
}

/* Divisores de seção reutilizando classe existente */
.section-divider {
    margin: 2rem 0 1rem 0;
    padding-top: 1rem;
    border-top: 1px solid #e9ecef;
}

.section-divider:first-of-type {
    border-top: none;
    margin-top: 0;
}

/* Classe para valores azuis existente no projeto */
.blue {
    color: #FE8D18 !important;
}

/* Responsividade */
@media (max-width: 768px) {
    .user-details-header {
        flex-direction: column;
        text-align: center;
        gap: 1rem;
    }

    .user-photo-section {
        align-items: center;
    }

    .user-status-info {
        justify-content: center;
        flex-wrap: wrap;
    }

    .user-department,
    .user-email {
        justify-content: center;
    }
}

@media (max-width: 576px) {
    .user-details-header {
        padding: 1rem;
    }

    .circular--landscape {
        width: 80px;
        height: 80px;
    }

    .user-name-badge {
        padding: 0.5rem 0.75rem;
        font-size: 0.9rem;
    }

    .user-id {
        font-size: 1.2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/User/View.vue